import { render, staticRenderFns } from "./MessageImage.vue?vue&type=template&id=5231f56c&scoped=true&"
import script from "./MessageImage.vue?vue&type=script&lang=ts&"
export * from "./MessageImage.vue?vue&type=script&lang=ts&"
import style0 from "./MessageImage.vue?vue&type=style&index=0&id=5231f56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5231f56c",
  null
  
)

export default component.exports